<template>
  <div
    v-if="def && def.componentPath"
    :id="`${def.name}-form-container`"
  >
    <component
      :is="formComponent"
      :def="def"
      :mode="mode"
      :model="model"
      :modal="modal"
      :page-modal="pageModal"
      :callback="callback"
    ></component>
  </div>
  <AppCard
    v-else-if="def && productLoaded"
    :id="`${def.name}-form-container`"
    :key="render"
    flat
    style="border-radius: 10px !important; overflow: hidden"
  >
    <!-- <div dir="ltr" class="pa-3" style="height: 100px; overflow: auto">
    form model ==> {{model.__proxy__.dirty}}
  </div> -->
    <!--    <div style="height: 88.5vh;" class="flex flex-column">-->
    <!--      <div v-if="def.header || def.header === undefined" class="px-4 d-flex justify-space-between" style="height: 45px;">-->
    <!--        <AppToolbarTitle class="mx-4">{{ $t(def) }}</AppToolbarTitle>-->
    <!--        <AppButton-->
    <!--            class="mx-1"-->
    <!--            v-for="action in def.actions && def.actions.filter(act => act.actionLocation && act.actionLocation.name === 'ECore.Def.DefEnums.Header')"-->
    <!--            :key="action.id"-->
    <!--            :def="{ form: def, ...action }"-->
    <!--            :model="Model"-->
    <!--            @click="action.onClick && $call(action.onClick)"-->
    <!--          >-->
    <!--            <v-icon-->
    <!--              class="font-weight-bold"-->
    <!--              medium-->
    <!--              :def="{ form: def, ...action }"-->
    <!--            >{{ action.iconName }}</v-icon>-->
    <!--        </AppButton>-->
    <!--      </div>-->
    <!--      <v-divider></v-divider>-->
    <!--      <div style="height: calc(89vh - 100px);overflow-y: auto">-->
    <!--        <v-tabs v-if="def.pages.length > 1">-->
    <!--          <v-tab-->
    <!--              v-for="page in def.pages"-->
    <!--              :key="page.id"-->
    <!--          >{{ $t(page) }}</v-tab>-->
    <!--          <v-tab-item v-for="page in def.pages" :key="page.id" class="tab_item">-->
    <!--            <v-divider></v-divider>-->
    <!--            <AbrPageContainer-->
    <!--                :def="def"-->
    <!--                :model="Model"-->
    <!--                :modal="modal"-->
    <!--                :mode="mode"-->
    <!--                :page="page"-->
    <!--            ></AbrPageContainer>-->
    <!--          </v-tab-item>-->
    <!--        </v-tabs>-->
    <!--        <AbrPageContainer-->
    <!--            v-else-->
    <!--            :def="def"-->
    <!--            :model="Model"-->
    <!--            :modal="modal"-->
    <!--            :mode="mode"-->
    <!--            :page="def.pages[0]"-->
    <!--        ></AbrPageContainer>-->
    <!--      </div>-->
    <!--      <div v-if="def.footer || def.footer === undefined" style="height: 60px; background-color: blue;">-->
    <!--        <AppButton-->
    <!--          v-for="action in (def.actions.filter(act => act.actionLocation && act.actionLocation.name === 'ECore.Def.DefEnums.Footer')).reverse()"-->
    <!--          :key="action.id"-->
    <!--          :def="{ form: def, ...action }"-->
    <!--          :model="Model"-->
    <!--          :modal="modal"-->
    <!--          :mode="mode"-->
    <!--          :text="action.name === 'fcaCancelButton'"-->
    <!--          @click="click(action)"-->
    <!--          class="mx-2"-->
    <!--        ></AppButton>-->
    <!--      </div>-->
    <!--    </div>-->
    <AppBar
      v-if="def.header || def.header === undefined"
      class="px-4 BG1"
      style="height: 6.7vh"
    >
      <div
        class="color_circle"
        :class="mode && mode.split('.').pop()"
      ></div>
      <AppToolbarTitle class="mx-4 ToolbarTitle">
        {{ $t(def) }}
      </AppToolbarTitle>

      <AppSpacer></AppSpacer>
      <div
        v-if="def.actions"
        class="d-flex"
      >
        <AppButton
          v-for="action in def.actions &&
            def.actions.filter(
              (act) =>
                act.actionLocation &&
                act.actionLocation.name === 'ECore.Def.DefEnums.Header'
            )"
          :key="action.id"
          class="mx-1"
          :def="{ form: def, ...action }"
          :model="Model"
          :text="(action.actionType &&
            action.actionType.name === 'ECore.Def.DefEnums.atIcon') ||
            action.actionType.name === 'ECore.Def.DefEnums.atRowAction'
          "
        >
        </AppButton>
      </div>
    </AppBar>
    <v-divider v-if="(def.header || def.header === undefined) && !(def.pages.length > 1)"></v-divider>
    <AppCard
      flat
      tile
    >
      <AbrStepper
        v-if="def.hasStepper"
        :model="Model"
        :def="def"
        :modal="modal"
        :mode="mode"
        :form-validate="formValidate"
        :save="save"
      />
      <v-tabs
        v-else-if="
          def.pages.filter((p, index) => pagesVisible[index]).length > 1
        "
      >
        <v-tab
          v-for="page in def.pages.filter((p, index) => pagesVisible[index])"
          :key="page.id"
        >
          {{ $t(page) }}
        </v-tab>
        <v-tab-item
          v-for="page in def.pages"
          :key="page.id"
          class="tab_item v_tab_item_height"
        >
          <v-divider></v-divider>
          <AbrPageContainer
            :def="def"
            :modal="modal"
            :mode="mode"
            :model="Model"
            :page="page"
          ></AbrPageContainer>
        </v-tab-item>
      </v-tabs>
      <AbrPageContainer
        v-else
        :def="def"
        :model="Model"
        :modal="modal"
        :mode="mode"
        :page="def.pages[0]"
      >
      </AbrPageContainer>
      <!-- <AppSlideButton class="slider-button"></AppSlideButton> -->
    </AppCard>
    <v-divider v-if="(def.footer || def.footer === undefined) && !def.hasStepper"></v-divider>
    <AppFooter
      v-if="(def.footer || def.footer === undefined) && !def.hasStepper"
      class="BG1"
      style="height: 6.7vh"
    >
      <AppPortalTarget :name="`${def.id}.footerActions`"></AppPortalTarget>
      <AppButton
        v-for="action in visibleFooterActions"
        :key="action.id"
        :def="{ form: def, ...action }"
        :model="Model"
        :modal="modal"
        :mode="mode"
        :outlined="action.name === 'fcaCancelButton'"
        class="mx-2"
        :disabled="disabledButton[action.name]"
        @click.native="save(action)"
      ></AppButton>
    </AppFooter>
  </AppCard>
</template>

<script>
import AppCard from "@/components/library/container/AppCard";
import AppButton from "@/components/library/action/AppButton";
// import AppSlideButton from "@/components/library/action/AppSlideButton";
import AppBar from "@/components/layout/AppBar";
import AppToolbarTitle from "@/components/layout/AppToolbarTitle";
import AppSpacer from "@/components/library/container/AppSpacer";
import AppFooter from "@/components/library/container/AppFooter";
import AbrPageContainer from "@/components/AbrPageContainer";
import { getCurrentState, submitDelete, submitFormData } from "../apis";
import AbrValidate from "../mixins/AbrValidate";
import AbrStepper from "./AbrStepper";
import AppPortalTarget from "@/components/library/portal/AppPortalTarget";
import { nextTick } from "vue";
import { ACTION_TAG } from "@/Strings/Constant.js";
import AbrEventsOff from "@/mixins/AbrEventsOff";


export default {
  name: "AbrForm",
  components: {
    AbrStepper,
    AbrPageContainer,
    AppFooter,
    AppSpacer,
    AppToolbarTitle,
    AppBar,
    AppButton,
    AppCard,
    AppPortalTarget,
    // AppSlideButton
  },
  // provide() {
  //   return {
  //     formStateMachine: () => this.prepareforInjectState()
  //   }
  // },
  mixins: [AbrValidate, AbrEventsOff],
  inject: ["changeFormMode"],
  props: ["def", "mode", "model", "modal", "pageModal", "callback"],
  data: (vm) => ({
    unwatch: {},
    // Model: vm.model,
    Model: Object.assign(vm.model, {
      __proxy__: {
        dirty: {},
        originalValues: { ...vm.model },
        isDirty: (prop) => vm.Model.__proxy__.dirty[prop],
        undo: (prop) => {
          vm.Model[prop] = vm.Model.__proxy__.originalValues[prop];
          vm.Model.__proxy__.dirty[prop] = false;
        },
      },
    }),
    errorMessages: undefined,
    formStateMachineObject: {},
    events: {},
    pagesVisible: [],
    productLoaded: !vm.def.product,
    disabledButton: {},
    visibleFooterActions: [],
    render: true,
    inputs: vm.def.hasStepper
      ? vm.def.pages.reduce((acc) => acc.push([]) && acc, [])
      : [],
  }),

  computed: {
    /**
     * @returns {string}
    */
    getFcaSubmitButtonTag() {
      return String(this.def?.actions?.find((action) => action?.id?.includes('fcaSubmitButton'))?.tags)?.trim()
    },
    /**
     * @returns {boolean}
    */
    canCloseModal() {
      return !this.getFcaSubmitButtonTag.includes(ACTION_TAG.KEEP_DIALOG_OPEN)
    },
    getDirty() {
      return (
        Object.keys(this.Model.__proxy__.dirty).filter(
          (key) => this.Model.__proxy__.dirty[key]
        ).length === 0
      );
    },
    formComponent() {
      return () =>
        this.def.componentPath && import("../ext/" + this.def.componentPath);
    },
    component() {
      return () =>
        this.def.pages[0].componentPath &&
        import("@/ext/" + this.def.pages[0].componentPath);
    },
  },
  async created() {
    await this.getState(this.model.ID);
    const actionVisible = (action) => {
      if (!action.visible) return true;
      let visible = true;
      if (this.mode.split(".").pop() in action.visible) {
        visible &= action.visible[this.mode.split(".").pop()];
      }
      return visible;
    };
    this.visibleFooterActions = await Promise.all(
      (this.def.actions ?? [])
        .filter(
          (action) =>
            action.actionLocation?.name === "ECore.Def.DefEnums.Footer" &&
            actionVisible(action)
        )
        .reverse()
    );

    // this.def.hasStepper && this.def.pages.map((page, index) => this.$set(this.inputs, index, []))
    this.def.eventHandlers &&
      (this.events = this.$processEvent(this.def.eventHandlers, this.def.id));

    this.$eventBus.$emit(`${this.def.id}-onLoad`);
    this.pagesVisible = await Promise.all(
      this.def.pages?.map((p) => this.$checkVisibility(p)) || []
    );
    this.$eventBus.$on('Form-State-Machine', (state) => {
      this.formStateMachineObject = state; // Update the parent data with the data sent from the child component
    });
    // this.$watch("$store.getters.getActiveTab.model.ID", async (nv) => {
    //   console.log("&&&&&&&&&&&&&&&&&&", nv)
    //   await this.getState(nv);
    // }, { deep: true, immediate: true });
    this.$eventBus.$on("GetPolicyState", (payload) => {
      this.getState(payload);
    });
    this.$eventBus.$on("Update-Form-State-Machine", (data) => {
      this.getState(data.formId, data.ID);
    });


     this.$watch("Model", (nv) => {
      // console.log(`%c  ${this.def.name} `, `color: #6eb5ff`, ' Model watch : ' , this.model );
    
      // console.log(this , nv ,"watchhhhhhhhhhhh");
      // if(this.def.product && this.mode === "ECore.Def.DefEnums.fmEdit") {
      //   this.$set(this, "disabledButton", {
      //     "fcaSubmitButton": this.getDirty 
      //   })
      // }
     }, { deep: true, immediate: true });
    nextTick(()=>{
      this.$eventBus.$emit(`${this.def.id}-onMounted`);
    })
  },

  mounted() {
    console.groupCollapsed(`%c  ${this.def.name} `, `color: #6eb5ff`, ' ==> AbrFormContainer ')
    console.log(`%c this.Model`, `color: #16e930`, '==>', ` AbrFormContainer `, '===>', this.Model)
    console.log(`%c this.def`, `color: #16e930`, '==>', ` AbrFormContainer `, '===>', this.def)
    console.log(`%c this.$formMode`, `color:  #16e930`, '==>', ` AbrFormContainer `, '===>', this.mode)
    console.log(`%c this.$store`, `color:  #16e930`, '==>', ` AbrFormContainer `, '===>', this.$store)
    console.groupEnd()
    this.calculateCancelBtnTags()
  },


  methods: {
    async getState(newModelID) {
      const activeTab = this.$store.getters.getActiveTab;
      if (!activeTab) return;
      const { form, model } = activeTab;
      const routeQuery = this.$route.query;
      const product = form?.product || routeQuery?.ProductDefID;
      const formID = this.def.hasSM ? this.$store.getters.getCurrentForm.formId || form.id : routeQuery?.ProductFormID;
      // const ID = (product && model?.ID) || routeQuery?.PolicyID;
      const version = this.$route.params.id === "$new" ? "latest" : typeof this.$route.params.id === "string" ? this.$route.params.id.split(':').pop() : this.$route.params.id
      const ID = `${this.$store.getters.getCurrentForm.model.ID}${typeof version === "string" ? ":" + version : ""}`;
      if (this.def.hasSM) {
        if (product && !this.$store.state.products[product || this.def.id]) {
          await this.$getProduct(product);
          this.productLoaded = true;
        }
        if (ID !== "not_set") {
          if (!ID) { return }
          if (!this.model.ID || ID.toString().split(':')[0] === "undefined") { return }
          const state = (ID || newModelID) && (await getCurrentState(formID, ID));

          // this.$store.state.stateMachine[
          //   `${this.$getProductInfo()?.id}-${this.def.id}` ?? this.def.hasSM
          //     ? `${this.def.product?.name}-${this.def.id}` || this.def.id
          //     : null
          // ] = state;

          if (state) {
            this.formStateMachineObject = state
            this.$store.state.statema
            this.$nextTick(() =>
              this.$eventBus.$emit("Pass-State-Machine", { state: this.formStateMachineObject, formID })
            );
            this.$nextTick(() =>
              this.$eventBus.$emit("ButtonRenderVisibility", { state: this.formStateMachineObject, formID })
            );
          }
          return
        }
        // this.$eventBus.$emit("ButtonRenderVisibility", state);
      }
    },
    // disable(action) {
    //   // if(!this.def.product) return;
    //   if(this.mode !== "ECore.Def.DefEnums.fmCreate") return false;
    //   if(action.name === 'fcaSubmitButton')
    //     return this.getDirty;
    // },

    resetProxy(newModel) {
      const proxy = this.Model.__proxy__.dirty;
      Object.keys(proxy).map((key) =>
        this.$set(this.Model.__proxy__.dirty, key, false)
      );
      this.$set(this.Model.__proxy__, "originalValues", newModel);
      const cFrm = this.$store.getters.getCurrentForm;
      !this.def.hasStepper && (this.render = !this.render);
    },

    register(prop, pageIndex) {
      if (this.def.hasStepper) {
        if (!pageIndex) return;
        pageIndex = this.def.pages.findIndex((page) => page.id === pageIndex);
        const isExist = this.inputs[pageIndex].some(
          (i) => i.def.id === prop.def.id
        );
        !isExist && this.inputs[pageIndex].push(prop);
      } else {
        this.inputs.push(prop);
      }
    },

    unregister(prop, pageIndex) {
      // check for stepper inputs
      if (this.def.hasStepper) {
        if (!pageIndex) return;
        pageIndex = this.def.pages.findIndex((page) => page.id === pageIndex);
        if (this.inputs[pageIndex].includes(prop)) {
          this.inputs[pageIndex].splice(
            this.inputs[pageIndex].indexOf(prop),
            1
          );
        }
      } else {
        this.inputs.includes(prop) &&
          this.inputs.splice(this.inputs.indexOf(prop), 1);
      }
    },

    async formValidate(pageId = undefined) {
      if (this.mode === "ECore.Def.DefEnums.fmDelete") return true;
      let inputs = this.inputs[pageId] ?? this.inputs;
      return (
        (
          await Promise.all(
            inputs.map(
              async (i) =>
                i.readonly ||
                ("visible" in i && !i.visible) ||
                (await i.validate())
            )
          )
        ).every((i) => i) && (await this.validate())
      );
    },

    async submitFormRequest(entityId, entity, fileData) {      
      if (
        this.mode === "ECore.Def.DefEnums.fmCreate" ||
        this.mode === "ECore.Def.DefEnums.fmEdit"
      ) {
        // const ID = (this.mode === 'ECore.Def.DefEnums.fmCreate') && entity.ID || "$new";
        let ID = "$new";
        if (this.mode === "ECore.Def.DefEnums.fmCreate")
          this.def.hasStepper ? (ID = entity.ID) : null;
        else {
          ID = entity.ID;
        }

        // entity = await submitFormData(entityId, entity, ID, this.def.id, fileData);
        let res = await submitFormData(
          entityId,
          entity,
          ID,
          this.def.id,
          fileData
        );
        this.resetProxy(res);
        if (res) {
          if (typeof this.callback === "function") this.callback(res);
          this.assign(this.Model, res);
          this.$store.dispatch("SHOW_SNACKBAR", {
            message: this.$t("ECore.Cmn.FixedMsg.FormSubmit"),
            color: "success",
          });
          entity = res
        }
      } else if (this.mode === "ECore.Def.DefEnums.fmDelete") {
        entity =
          (await submitDelete(entityId, entity, entity.ID, this.def.id)) || {};
      }
      if (entity) {
        const currentForm = this.$store.getters?.getActiveTab;
        const LastActiveTabSearchForm = this.$store.getters?.getCurrentForm?.lastActiveTab
        const lastActiveTab = LastActiveTabSearchForm?.name;        
        const CurrentSearchForm = currentForm?.form?.pages[0]?.searchConfig; 

currentForm?.form?.pages?.forEach(page => {
  page?.sections?.forEach(section => {
    section?.panels?.forEach(panel => {
      if (panel?.grids) {
        panel?.grids.forEach(searchConfig => {
          if (searchConfig?.searchConfig?.refreshOnSubmit) {
           this.$eventBus.$emit(`UpdateSearchPage-${currentForm.route.name}`);   
          }
        });
      }
    });
  });
});

        if (CurrentSearchForm ) {   
          if(CurrentSearchForm.refreshOnSubmit)
           this.$eventBus.$emit(`UpdateSearchPage-${currentForm.route.name}`);   
        } else if (lastActiveTab) {  
          const refreshOnSubmit = LastActiveTabSearchForm?.params?.form?.pages?.find((n)=>n.searchConfig?.refreshOnSubmit)?true:false;          
          if(refreshOnSubmit) 
          this.$eventBus.$emit(`UpdateSearchPage-${lastActiveTab}`);
        }
      }
      return entity;
    },

    getDirtyValues() {
      const isModelKeyDirty = (key) => {
        const dirtyObject = this.model.__proxy__.dirty
        const isKeyDirty = new Map(Object.entries(dirtyObject)).get(key)
        return !!isKeyDirty
      }

      // eslint-disable-next-line no-unused-vars
      const modelRels = Object.entries(this.Model)
        .filter(
          ([key, value]) =>
            !key.startsWith("__") && typeof value === "object" && value !== null
        )
        .map(([key, value]) => [
          key,
          Array.isArray(value) && value.length >= 0 && isModelKeyDirty(key)
            ? value.map((item) => getNestedDirties(item))
            : !Array.isArray(value) && getNestedDirties(value),
        ]);

      function getNestedDirties(object) {
        if (!object.ID) {
          object.__proxy__ && delete object.__proxy__;
          return object;
        }
        if (object.ID && !object.__proxy__) return object
        if (object.Deleted) return object;
        if (!object.__proxy__) return;
        const dirties = object.__proxy__.dirty;
        return Object.entries(object).reduce(
          (acc, [key, value]) =>
            ((dirties[key] || key === "ID") &&
              Object.assign(acc, { [key]: value })) ||
            acc,
          {}
        );
      }

      function mergeModels(accumalator) {
        return modelRels.reduce((acc, [key, value]) => {
          if (!(value && !key.startsWith("$") && !key.startsWith("__")))
            return acc;
          if (Array.isArray(value)) {
            return (
              (value.filter((item) => item).length > 0 && {
                ...acc,
                [key]: value.filter((item) => item),
              }) ||
              acc
            );
          }
          if (typeof value === "object") {
            return { ...acc, [key]: getNestedDirties(value) };
          }
          return acc; // value && !key.startsWith("$") && !key.startsWith("__") && value.filter(item => item).length > 0 && ({ ...acc, [key]: value.filter(item => item) }) || acc
        }, accumalator);
      }
      const res = getNestedDirties(this.Model);
      const dirtyObject = mergeModels(res);

      function emptyJSon(obj){
        let count = 0 ;
        for(const key in obj){
          if(key!='ID') count += 1
          if(count>0) break;
        }
        return count==0;
      }

      function clearEmptyArrays(Obj){
        for(const key in Obj){
          let value = Obj[key];
          if(typeof value =='object'){
            if(Array.isArray(value)){              
              if(value.length==0){
                // Delete this Array
                delete Obj[key];              
              }else{
                value.forEach((node)=>{
                  node = clearEmptyArrays(node);                  
                });

                let max = value.length;
                let index = 0;
                while(index<max){
                  if(emptyJSon(value[index])){
                    value.splice(index,1);
                    max = value.length;
                  }else{
                    index += 1;
                  }
                }
                if(value.length==0){
                // Delete this Array
                delete Obj[key];              
              }
              }
            }else{
              value = clearEmptyArrays(value);
            }
          }
        }


        return Obj;
      }

      let dirtyObject2 = JSON.parse(JSON.stringify(dirtyObject))

      // dirtyObject2 = clearEmptyArrays(dirtyObject2);    

      return {
        ...dirtyObject2,
        Permissions: this.Model?.Permissions,
        ClaimPayees: this.Model.ClaimPayees
        // need to delete ClaimPayees Asap
      };
      // const recursion = (object) => {
      //   if(!object.__proxy__) return object;
      //   const dirties = object.__proxy__.dirty;
      //   return Object.keys(object).filter((key) => dirties[key]).reduce((acc, cur) => {
      //     let preparedObject = object[cur];
      //     if(object[cur] !== null && typeof object[cur] === "object") {
      //       console.log(object[cur], cur);
      //       preparedObject = recursion(object[cur])
      //     }
      //     if(Array.isArray(object)) {
      //       return [ ...acc, preparedObject ];
      //     }
      //     return { ...acc, [cur]: preparedObject };
      //   }, Array.isArray(object) ? [] : {});
      // }
      // const test = recursion(this.model)
      // return { ID: this.Model.ID, ...test };
    },
    // ########################

    async save(action, pageIndex = undefined) {
      // Form Data Save and No Close Form            
      if (action.name === "fcaNotCloseSubmit") {
        let valid = await this.formValidate(pageIndex);
        if (!valid) return;
        const entityId = this.def.origin?.name;
        let entity = JSON.parse(JSON.stringify(this.Model));
        const result = await this.submitFormRequest(entityId, entity);
        if (!result) return;
        if (typeof this.callback === "function") this.callback(result);
        this.$store.dispatch("SHOW_SNACKBAR", {
          message: this.$t("ECore.Cmn.FixedMsg.FormSubmit"),
          color: "success",
        });

        if (this.$route.params.id === "$new") {
  this.$route.params.id = this.model.ID;

  await this.$router.replace({
    name: this.$route.name,
    params: { id: this.model.ID }
  });

  this.changeFormMode("ECore.Def.DefEnums.fmView");
}
        
      }
      if (action.name === "fcaSubmitRequstState") {
        let valid = await this.formValidate(pageIndex);
        if (!valid) return;
        const entityId = this.def.origin?.name;
        let entity = JSON.parse(JSON.stringify(this.Model));
        // Remove SharePrjDetails from entity
        delete entity.SharePrjDetails;
        const result = await this.submitFormRequest(entityId, entity);
        if (!result) return;

        const interval = setInterval(() => {
          if (!this.$store.state.isLoading) {
            this.$eventBus.$emit("GetPolicyState");
            clearInterval(interval);
          }
        }, 400);

      }

      if (action.name === "fcaSubmitButton") {
        let valid = await this.formValidate(pageIndex);
        if (!valid) return;
        
        const entityId = this.def.origin?.name;
        let entity = JSON.parse(JSON.stringify(this.Model));

        if (
          typeof this.modal?.close === "function" ||
          typeof this.pageModal?.close === "function"
        ) {
          let res = entity;
          if (this.def.isSelfCRUD) {            
            if (this.mode.split(".").pop() === "fmCreate") {              
              entity = entity = JSON.parse(JSON.stringify(this.Model));
            } else {              
              entity = this.getDirtyValues();
            }            
            res = await this.submitFormRequest(
              entityId,
              entity,
              this.Model.FileData
            );
            if (!res)return;
          }
          if (this.canCloseModal || this.mode.split(".").pop() === "fmDelete") {
            (this.modal || {}).close(action.modalResult?.name, res);
          } else {
            this.updatedAndRerenderCurrentForm()
            this.updatedAndRerenderRootForm()
          }
          if (this.events?.custom && "onAfterSubmit" in this.events?.custom) {
            this.$store.dispatch("EVENT_EMITTER", {
              target: "onAfterSubmit",
              context: this,
            });
            await this.$eval(this.events?.custom?.onAfterSubmit?.script);
          }
        } else {
          if (this.mode.split(".").pop() === "fmCreate" && !entity.ID) {

            if (this.model.ID && (this.model?.PayOrderDeposits && this.model?.PayOrderDeposits.length !== 0) || (this.model.CommPrjDetails && this.model.CommPrjDetails.length !== 0)) {
              // this is if check for handling payload in frmcommprj && frmpayorder for not updating deposit no in create mode
              const nv = this.Model
              delete nv?.PayOrderDeposits
              delete nv?.CommPrjDetails
              entity = entity = JSON.parse(JSON.stringify(nv));
            }
            else entity = entity = JSON.parse(JSON.stringify(this.Model));
          }
          else {
            entity = this.getDirtyValues();
          }
          const result = await this.submitFormRequest(entityId, entity);


          if (!result) return;

          if (this.events?.custom && "onAfterSubmit" in this.events?.custom) {
            this.$store.dispatch("EVENT_EMITTER", {
              target: "onAfterSubmit",
              context: this,
            });
            await this.$eval(this.events?.custom?.onAfterSubmit?.script);
          }
          if (
            !this.def.hasStepper &&
            this.mode !== "ECore.Def.DefEnums.fmEdit"
          ) {
            const lastActiveTab =
              this.$store.getters.getActiveTab.lastActiveTab;
            await this.$store.dispatch(
              "DELETE_TAB",
              this.$store.state.tabManagement.activeTab
            );
            if (this.$store.getters.tabs.length === 0)
              await this.$router.push({ name: "AppHome" });
            else {
              if (this.tabExist(lastActiveTab)) {
                await this.$router.push(lastActiveTab);
              } else {
                await this.$router.push(
                  this.$store.state.tabManagement.tabs[
                    this.$store.state.tabManagement.tabs.length - 1
                  ].route
                );
              }
            }
          }
          
          return true;
        }


      } else if (action.name === "fcaCancelButton") {
        if (
          typeof this.modal?.close === "function" ||
          typeof this.pageModal?.close === "function"
        ) {
          (this.modal || this.pageModal).close(action.modalResult?.name);
          if (!this.canCloseModal) {
            // this.updatedAndRerenderRootForm()
          }

        } else {
          const lastActiveTab = this.$store.getters.getActiveTab.lastActiveTab;
          await this.$store.dispatch(
            "DELETE_TAB",
            this.$store.state.tabManagement.activeTab
          );
          if (this.$store.getters.tabs.length === 0)
            await this.$router.push({ name: "AppHome" });
          else {
            if (this.tabExist(lastActiveTab)) {
              await this.$router.push(lastActiveTab);
            } else {
              await this.$router.push(
                this.$store.state.tabManagement.tabs[
                  this.$store.state.tabManagement.tabs.length - 1
                ].route
              );
            }
            return true;
          }
        }
      }
    },

    assign(target, source) {
      if (source)
        for (let k of Object.keys(source)) this.$set(target, k, source[k]);
      return target;
    },

    tabExist(toRoute) {
      return this.$store.state.tabManagement.tabs.some(
        (t) => t.route.name === toRoute.name
      );
    },

    async updatedAndRerenderRootForm() {
      const formId = this.$store.getters.getActiveTab.form.id
      const formName = this.$store.getters.getActiveTab.form.origin.name
      const ID = this.$store.getters.getFormModel.ID

      this.$store.dispatch('UPDATE_STATE_MACHINE', { formId, ID })

      nextTick(() => {
        this.$store.dispatch('UPDATE_AND_RERENDER_FORM', { formId, formName, ID })
      })

    },

    async updatedAndRerenderCurrentForm() {
      const formId = this.def.id
      const formName = this.def.origin.name
      const ID = this.model.ID
      this.$store.dispatch('UPDATE_STATE_MACHINE', { formId, ID })
      nextTick(() => {
        this.$store.dispatch('UPDATE_AND_RERENDER_FORM', { formId, formName, ID })
      })

    },

    async calculateCancelBtnTags() {
      const tags = this.def?.actions?.find((action) => action?.id?.includes('fcaCancelButton'))?.tags?.toString()?.trim()
      const shouldStopRootFormStepper = tags ? tags.includes(ACTION_TAG.STAY_IN_STEP) : false
      const formName = this.$store.getters.getActiveTab.form.name
      const modelId = this.$store.getters.getFormModel.ID ?? '$new'
      const canReset = !shouldStopRootFormStepper
      const step = this.$store.getters.getCurrentFormStep[formName] ? this.$store.getters.getCurrentFormStep[formName].step : 1

      this.$store.commit('ADD_OR_REPLACE_FORM_STEP', { [formName]: { modelId, canReset, step } })

    }

  },
};
</script>

<style lang="scss">
.v-tab {
  letter-spacing: 0 !important;
}

.v-tabs-slider {
  height: 1.5px !important;
  width: 50% !important;
  transform: translate(-50%, 50%) !important;
}

.color_circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: red;

  &.fmCreate {
    background-color: #389d2f;
  }

  &.fmEdit {
    background-color: #fec941;
  }

  &.fmView {
    background-color: #2969e3;
  }

  &.fmDelete {
    background-color: #b00020;
  }
}

.v_tab_item_height {
  min-height: 69.6vh;
}

.v-tabs-slider {
  background-color: #f6921d !important;
}

.ToolbarTitle {
  font-family: IRANYekan;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 31px;
}

// .slider-button {
//   margin-bottom: 50px;
// }</style>